import util from '@tencent/vft-common/util';

const sportHandler = async function ({ cid, vid }) {
  if (!cid && !vid) return false;

  const { isQQSports } = window.magicApp?.env;

  if (!isQQSports) return false;

  util.loadScript('qqsport-sdk', '//mat1.gtimg.com/sports/sportAppWeb/tua-app-sdk/tua-sports-bridge.js', () => {
    window.TencentSports.open({
      type: 204,
      param: {
        cid,
        vid,
      },
    });
  });

  return true;
};

export default sportHandler;
